import {
  checkDuplicateStaff,
  checkDuplicateStudents,
  checkPassword,
  checkProgramCode,
  correctHeaders,
  CsvValidationError,
  hasBlankCells,
  hasIncorrectNumOfCells,
} from '@/components/common/Validations/CsvValidations';

export interface RosterCsvCheckResult {
  errors: CsvValidationError[];
  rowCount: number;
}

// single source of the roster CSV check sequence, shared by the manual upload modal and the
// SFTP Files card so their results cannot drift
export const checkRosterCsv = (
  text: string,
  importType: string,
  programCodes: string[],
  strictPasswordPolicies: string[],
): RosterCsvCheckResult => {
  const rowStrings = text.split(/[\r\n]+/g);
  const rows = rowStrings.map(row => row.split(','));
  const rowCount = rowStrings.filter(str => str.length !== 0).length;
  const uniqueRows: object[] = [];
  const headerRow = rows.shift() ?? [];
  let errors = correctHeaders(headerRow, importType);

  rows.forEach((cells, index) => {
    const rowNum = index + 2;
    if (cells.length === 1 && cells[0] === '') return;

    const rowError = hasIncorrectNumOfCells(cells, importType, rowNum);
    if (rowError.length) {
      errors = errors.concat(rowError);
      return;
    }

    errors = errors.concat(hasBlankCells(cells, rowNum));
    if (importType === 'staff') {
      errors = errors.concat(checkPassword(cells[3], cells[4], rowNum, strictPasswordPolicies.includes('Teacher')));
      errors = errors.concat(checkProgramCode(cells[5], programCodes, rowNum));
      errors = errors.concat(checkDuplicateStaff(cells, rowNum, uniqueRows));
    } else {
      errors = errors.concat(checkPassword(cells[3], cells[4], rowNum, strictPasswordPolicies.includes('Student')));
      errors = errors.concat(checkProgramCode(cells[6], programCodes, rowNum));
      errors = errors.concat(checkDuplicateStudents(cells, importType, rowNum, uniqueRows));
    }
  });

  return { errors, rowCount };
};
